<template>
    <div class="modal fade"
         id="detailModal"
         tabindex="-1"
         role="dialog"
         aria-labelledby="exampleModalLabel"
         aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document" style="width:70%;max-width:70%;">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title pull-left">Consulta do dia {{ selectedEvent.dds_date | brDate }}</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <button v-if="enableDelete"
                                class="btn btn-danger"
                                @click="deleteEvent(selectedEvent.dds_date)">
                            <i class="fa fa-trash"></i> Deletar
                        </button>
                        <hr>
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th style="width:280px">Título</th>
                                    <th>Área</th>
                                    <th>Turno</th>
                                    <th style="width:110px">Horário</th>
                                    <th>Status</th>
                                    <th>Participantes</th>
                                    <th>Terceiros</th>
                                    <th>Quantidade na Área</th>
                                    <th>% Participação</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(event, index) in selectedEvents" :key="event.id">
                                    <td v-if="!event.editing">{{ (event.theme) ? event.theme.title : '-' }}</td>
                                    <td v-if="event.editing">
                                        <v-select 
                                        :options="themes"
                                        label="title"
                                        :reduce="theme => theme.id"
                                        :clearable="false"
                                        v-model="event.newTheme.id"
                                    ></v-select>            
                                    </td>
                                    <td>{{ (event.teams_shifts && event.teams_shifts.team.name) ? event.teams_shifts.team.name : 
                                        event.team.name ? event.team.name : '-' }}
                                    </td>
                                    <td>{{ (event.teams_shifts && event.teams_shifts.shift.name) ? event.teams_shifts.shift.name : '-' }}</td>
                                    <td v-if="!event.editing">{{ new Date(event.dds_date).toLocaleTimeString() }}</td>
                                    <td v-if="event.editing">
                                        <input type="time" v-model="event.newTime" class="form-control"/>
                                    </td>
                                    <td>{{ (event.status) ? event.status.name : '-' }}</td>
                                    <td>{{ (event.participants) ? event.participants : '-' }}</td>
                                    <td>{{ (event.participants_external) ? event.participants_external : '-' }}</td>
                                    <td>{{ (event.teams_shifts && event.teams_shifts.people) ? event.teams_shifts.people : '-' }}</td>
                                    <td v-if="event.status_id == 3 && event.teams_shifts.people > 0">{{ 
                                            (parseFloat((event.participants + event.participants_external) / event.teams_shifts.people * 100).toFixed(0) > 100 ? 
                                                100 :
                                                parseFloat((event.participants + event.participants_external) / event.teams_shifts.people * 100).toFixed(0) 
                                            )
                                        }}%
                                    </td>
                                    <td v-else>N/A</td>
                                    <td>            
                                    <a
                                      v-show="event.status_id !=  3"
                                      data-toggle="tooltip"
                                      data-dismiss="modal"
                                      title="Deletar"
                                      class="btn btn-danger fa fa-trash"
                                      @click="destroy(event.id, index)"
                                    ></a>
                                    <a
                                      v-show="event.status_id !=  3"
                                      data-toggle="tooltip"
                                      title="Editar"
                                      class="btn btn-warning fa fa-pencil"
                                      @click="edit(event)"                                        
                                    ></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success pull-left" data-dismiss="modal" aria-label="Close">
                        Fechar
                    </button>
                    <button @click="save" type="button" class="btn" style="background-color: green; color:white" aria-label="Close">
                        Salvar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            };
        },
        props: ["selectedEvents", "selectedEvent", "enableDelete", "themes"],
        methods: {
            save(){
                this.selectedEvents.forEach(event => {
                    event.theme_id = event.newTheme.id
                    event.theme.title = this.themes.find(theme => theme.id == event.newTheme.id).title
                    event.dds_date = event.dds_date.substr(0,11) + event.newTime + ':00'
                    let form = new FormData();
                                
                    form.append("theme_id", event.newTheme.id);
                    form.append("dds_date", event.dds_date);

                    const self = this;
                    const api = self.$store.getters.api + "events/" + event.id;
                                    
                    self.$http
                      .post(api, form)
                      .then((response) => {
                        this.$parent.getEvents();
                        event.editing = false;
                        this.$forceUpdate();
                        self.$message(null, "Evento editado com sucesso", "success");
                      })
                      .catch((error) => {
                          self.$error("Não foi possível editar o evento");
                      });
                })
            },
            edit(event){
                if(event.editing){
                    event.editing = false
                    this.$forceUpdate();
                    return
                }
                event.editing = true
                this.$forceUpdate();
            },
            deleteEvent(date) {
                const self = this;
                const api = self.$store.getters.api + "events/delete";

                swal({
                    title: "Deseja deletar o registro?",
                    text: "Somente será deletado os eventos Programados",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Sim, deletar!",
                    showLoaderOnConfirm: true,
                    buttons: {
                        catch: {
                            text: "Não",
                            value: "cancel",
                            className: "btn-danger"
                        },
                        confirm: {
                            text: "Sim",
                            value: "confirm"
                        }
                    }
                })
                    .then(value => {
                        switch (value) {
                            case "cancel":
                                swal("Cancelado", "O registro não foi excluido!", "info");
                                break;

                            case "confirm":
                                self.$http
                                    .post(api, {
                                        dds_date: date
                                    })
                                    .then(response => {
                                        self.$message(null, "Eventos deletados com sucesso", "success");
                                    })
                                    .then(() => {
                                        $("#detailModal").modal("toggle");
                                        self.$emit("deleteEvents");
                                    });
                                break;
                        }
                    });
            },
            destroy(id, index) {
              const self = this;
            
              swal({
                title: "Deseja deletar o registro?",
                text: "Essa operação não pode ser desfeita",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, deletar!",
                showLoaderOnConfirm: true,
                buttons: {
                  catch: {
                    text: "Não",
                    value: "cancel",
                    className: "btn-danger"
                  },
                  confirm: {
                    text: "Sim",
                    value: "confirm"
                  }
                }
              }).then(value => {
                switch (value) {
                  case "cancel":
                    swal("Cancelado", "O registro não foi excluido!", "info");
                    break;
                  case "confirm":
                    self.$http
                      .delete(self.$store.getters.api + "events/" +  id, {
                        id: id
                      })
                      .then(response => {
                        self.selectedEvents.splice(index, 1);
                        this.$parent.getEvents();
                        swal("Sucesso", "Registro excluído com sucesso!", "success");
                      })
                      .catch(errors => {
                        let error = errors.response ? errors.response.data : errors;
                        swal("Erro", error, "error");
                      });
                    break;
                }
              });
            },

        },
        filters: {
            brDate(date) {
                if (date) {
                    return (date.substr(8, 2) + "/" + date.substr(5, 2) + "/" + date.substr(0, 4));
                }
                return '';
            }
        }
    }
</script>

<style scoped>
    .scroll-modal {
        max-height: 480px;
        overflow: overlay;
    }

    @media screen and (max-width: 767px) {
        .scroll-modal {
            max-height: unset;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/Schedule/DetailModal.vue